<template>
  <validation-observer ref="evaluationRow">
    <div class="bg-secondary-13 rounded p-3">
      <div>
        <div class="row">
          <div class="col-12 col-md-3">
            <template v-if="insertMode">
              <validation-provider v-slot="{ errors }" rules="required">
                <custom-drop-down
                  v-if="reEvaluation"
                  v-model="model.date"
                  custom-error-msg="La fecha es requerida."
                  :error="errors[0]"
                  fieldkey="id"
                  fieldname="name"
                  :label="dateTitle"
                  :options="dateOptions"
                  placeholder="Seleccione"
                />
                <custom-date-picker
                  v-else
                  v-model="model.date"
                  class-container=""
                  custom-error-msg="La fecha es requerida."
                  :error="errors[0]"
                  :label="dateTitle"
                  :max-date="new Date()"
                  placeholder="DD/MM/YYYY"
                />
              </validation-provider>
            </template>
            <div v-if="model.diagnosis && !insertMode">
              <div class="color-gray-6 font-14 font-weight-normal">
                {{ dateTitle }}
              </div>
              <span class="color-black font-16 font-weight-normal">
                {{ getFormatedDate(this.model.date) }}
              </span>
            </div>
          </div>
          <div class="col-12 col-md-9 mt-2 mt-md-0">
            <validation-provider
              v-if="insertMode"
              v-slot="{ errors }"
              rules="required"
            >
              <custom-input
                v-model="model.diagnosis"
                custom-error-msg="El diagnóstico es requerido."
                :error="errors[0]"
                label="Diagnóstico:"
                maxlength="500"
              />
            </validation-provider>
            <div v-if="model.diagnosis && !insertMode">
              <div class="color-gray-6 font-14 font-weight-normal">
                Diagnóstico:
              </div>
              <span class="color-black font-16 font-weight-normal">
                {{ this.model.diagnosis }}
              </span>
            </div>
          </div>
          <div v-if="reEvaluation" class="col-12 col-md-3">
            <template v-if="insertMode">
              <custom-date-picker
                v-model="model.confirmedDate"
                class-container=""
                :label="confirmDateTitle"
                :max-date="new Date()"
                placeholder="DD/MM/YYYY"
              />
            </template>
            <div v-if="model.diagnosis && !insertMode">
              <div class="color-gray-6 font-14 font-weight-normal">
                {{ confirmDateTitle }}
              </div>
              <span class="color-black font-16 font-weight-normal">
                {{ this.model.confirmedDate | date }}
              </span>
            </div>
          </div>
          <div
            v-if="model.diagnosis && !insertMode && !disabled"
            class="col d-flex justify-content-end align-items-center"
          >
            <dropdown
              class="actions-dropdown"
              :items="actionItems"
              title="Acciones"
            />
          </div>
        </div>
        <div class="d-md-flex justify-content-end align-items-center mt-3">
          <div v-if="insertMode">
            <action-button
              class="px-3 mr-2"
              :disabled="disabled"
              i="fas fa-times-circle"
              text="Cancelar"
              variant="outline-danger"
              @click="cancelEvaluation"
            />
            <action-button
              class="px-3 mt-2 mt-md-0"
              :disabled="disabled"
              i="fas fa-file-plus"
              text="Añadir"
              variant="success"
              @click="addEvaluation"
            />
          </div>
        </div>
      </div>
      <div
        v-if="!model.diagnosis && !insertMode"
        class="d-flex justify-content-center align-items-center"
      >
        <action-button
          class="border btn px-5"
          :disabled="disabled"
          i="fas fa-file-plus color-green"
          :text="addTitle"
          @click="add()"
        />
      </div>
    </div>
  </validation-observer>
</template>

<script>
import CustomDropDown from 'custom-drop-down';
import CustomInput from 'CustomInput';
import ActionButton from 'ActionButton';
import Dropdown from 'dropdown';
import CustomDatePicker from 'custom-date-picker';
import moment from 'moment';

export default {
  name: 'EvaluationRow',
  components: {
    CustomDropDown,
    CustomInput,
    ActionButton,
    Dropdown,
    CustomDatePicker,
  },
  props: {
    info: {
      type: Object,
      default: () => {},
    },
    dateOptions: {
      type: Array,
      default: () => [],
    },
    defaultDate: {
      type: String,
      default: () => null,
    },
    defaultConfirmedDate: {
      type: String,
      default: () => null,
    },
    reEvaluation: {
      type: Boolean,
      default: () => false,
    },
    addTitle: {
      type: String,
      default: () => '',
    },
    dateTitle: {
      type: String,
      default: () => '',
    },
    confirmDateTitle: {
      type: String,
      default: () => '',
    },
    firstItem: {
      type: Boolean,
      default: () => true,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      insertMode: null,
      isAdded: null,
      model: {
        date: this.defaultDate,
        confirmedDate: this.defaultConfirmedDate,
        diagnosis: null,
      },
    };
  },
  computed: {
    actionItems() {
      let actions = [
        {
          name: 'edit',
          label: 'Editar',
          icon: 'fas fa-edit text-green pr-1',
          click: () => {
            this.insertMode = true;
          },
        },
        {
          name: 'delete',
          label: 'Eliminar',
          icon: 'fas fa-times-circle color-red pr-1',
          click: this.deleteEvaluation,
        },
      ];
      return actions;
    },
  },
  watch: {
    defaultDate: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.model.date = newVal;
        }
      },
    },
    defaultCofirmedDate: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.model.confirmedDate = newVal;
        }
      },
    },
    info: {
      immediate: true,
      handler(current) {
        if (current && Object.keys(current).length) {
          this.model = { ...current };
          if (this.model.date && this.dateOptions.length > 0) {
            var date = this.dateOptions.find((x) => x.name == this.model.date);
            this.model.date = date ? date : this.model.date;
          }
          this.isAdded = this.model.id != 0;
          return;
        }
        this.reset();
        this.isAdded = false;
      },
    },
  },
  methods: {
    getFormatedDate(value) {
      if (!value) {
        return value;
      }

      value = value.default || value;
      return moment(value).isValid()
        ? moment(value)
            .locale('es-PR')
            .format('DD/MMM/YYYY')
        : value;
    },
    add() {
      this.insertMode = true;
    },
    async addEvaluation() {
      const isValid = await this.$refs.evaluationRow.validate();
      if (!isValid) {
        return;
      }
      this.isAdded = true;
      this.insertMode = false;
      this.$emit('save', this.model);
    },
    deleteEvaluation() {
      if (this.reEvaluation) {
        this.$emit('cancel');
        return;
      }
      this.reset();
      this.$emit('save', this.model);
    },
    cancelEvaluation() {
      if (this.reEvaluation && !this.firstItem) {
        this.$emit('cancel');
        return;
      }
      this.reset();
    },
    reset() {
      this.insertMode = null;
      this.model = {};
    },
  },
};
</script>
